import api from '../utils/api';

export const getAllProducts = async () => {
    try {
        const response = await api.get('/products');
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch products');
    }
};

export const getProductById = async (id) => {
    try {
        const response = await api.get(`/products/${id}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch product');
    }
};

export const getProductBySku = async (sku) => {
    try {
        const response = await api.get(`/products/sku/${sku}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch product by SKU');
    }
};

export const getProductByCodeBarre = async (codeBarre) => {
    try {
        const response = await api.get(`/products/codebarre/${codeBarre}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch product by SKU');
    }
};

export const searchProducts = async (name) => {
    try {
        const response = await api.get(`/products/search?name=${encodeURIComponent(name)}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to search products');
    }
};

export const getProductsByCategory = async (category) => {
    try {
        const response = await api.get(`/products/category/${category}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch products by category');
    }
};

export const createProduct = async (productData, images, mainImageIndex = 0) => {
    try {
        // Create a FormData object to send the file and product data
        const formData = new FormData();

        // Add product data as a JSON string
        formData.append('product', new Blob([JSON.stringify(productData)], {
            type: 'application/json'
        }));

        // Add images if they exist
        if (images && images.length > 0) {
            images.forEach(image => {
                formData.append('images', image);
            });
        }

        // Add main image index
        formData.append('mainImageIndex', mainImageIndex);

        const response = await api.post('/products', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to create product');
    }
};

export const createMultipleProducts = async (products, imagesList, mainImageIndices) => {
    try {
        // Création d'un FormData pour envoyer les données et fichiers
        const formData = new FormData();

        // Conversion des produits en JSON et ajout au FormData
        formData.append('products', new Blob([JSON.stringify(products)], {
            type: 'application/json'
        }));

        // Ajout des images avec la nomenclature appropriée pour Spring
        imagesList.forEach((productImages, productIndex) => {
            productImages.forEach((image) => {
                formData.append(`imagesList[${productIndex}]`, image);
            });
        });

        // Ajout des indices d'images principales
        mainImageIndices.forEach((mainIndex, productIndex) => {
            formData.append(`mainImageIndices[${productIndex}]`, mainIndex);
        });

        // Passe par l'instance axios `api` : baseURL (/soplast/api) + token JWT gérés automatiquement
        const response = await api.post('/products/bulk', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        return response.data;
    } catch (error) {
        console.error('Error creating multiple products:', error);
        throw error.response ? error.response.data : error;
    }
};

export const updateProduct = async (id, productData) => {
    try {
        const response = await api.put(`/products/${id}`, productData);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to update product');
    }
};

export const addProductImage = async (productId, imageFile, isMain) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('isMain', isMain.toString());

        // Passe par l'instance axios `api` : baseURL (/soplast/api) + token JWT gérés automatiquement
        const response = await api.post(`/products/${productId}/images`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        return response.data;
    } catch (error) {
        console.error('Error adding product image:', error);
        throw error.response ? error.response.data : error;
    }
};

export const removeProductImage = async (productId, imageId) => {
    try {
        const response = await api.delete(`/products/${productId}/images/${imageId}`);
        return response.data;
    } catch (error) {
        console.error('Error removing product image:', error);
        throw error.response ? error.response.data : error;
    }
};

export const deleteProduct = async (id) => {
    try {
        const response = await api.delete(`/products/${id}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to delete product');
    }
};

export const deleteMultipleProducts = async (ids) => {
    try {
        const response = await api.delete('/products/bulk', { data: ids });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to delete multiple products');
    }
};

export const updateStock = async (id, quantity) => {
    try {
        const response = await api.put(`/products/${id}/stock`, { quantity });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to update stock');
    }
};